export const cartReducer = (state, action)=>{
    switch(action.type)
    {
        case "addproducts" : return {...state, products: action.payload} ;
        case "addtocart" : return {...state, cart:[{...action.payload}, ...state.cart]}
        case "removefromcart" : return {...state, cart:state.cart.filter((c)=>{
            return c.id !== action.payload.id
        })}
        case "changeproductqty" : return {...state, cart: state.cart.filter((c)=>{
            return c.id === action.payload.id ? c.qty=action.payload.qty : c.qty
        })}
        default: break;
    }
}